<template>
    <!-- Begin:PageContent-FurtherServices, PromoBox -->
    <section id="content" v-if="getFlagSharedShowFlightSearchResults === false">
        <!-- Begin:FurtherServices -->
        <div class="container">
            <div class="travel-ideas">
                <h1 class="idea-title travel-ideas"><span class="index"><i class="soap-icon-star circle"></i></span>{{ contentheadline[getCurrentLocale] }}</h1>
            </div>

            <div class="block">
                <div class="row">

                    <!-- Begin:TravelExtras-Left -->
                    <div class="col-sm-6">
                        <div class="toggle-container with-image box" id="accordion3" data-image-animation-type="zoomIn" data-image-animation-duration="1">
                            <div class="image-container animated fadeIn" data-animation-type="fadeIn" data-animation-duration="3" style="animation-duration: 3s; visibility: visible;">
                                <img src="/res/images/travelextras/tabs03.png" alt="img1" />
                            </div>

                            <!-- Begin:TravelExtras-Seat -->
                            <div class="panel style1">
                                <h4 class="panel-title">
                                    <a class="collapsed" href="#acc7" data-toggle="collapse" data-parent="#accordion3">{{ furtherservices_seat[getCurrentLocale] }}</a>
                                </h4>
                                <div class="panel-collapse collapse" id="acc7">
                                    <div class="panel-content">
                                        <p>
                                            <div class="intro box">
                                                <p>{{ furtherservices_seat_headline[getCurrentLocale] }}</p><br />
                                                <div class="image-box style14">
                                                    <article class="box">
                                                        <figure>
                                                            <img src="/res/images/services/seats/types/seat1.png" alt="" width="30" heigth="30" style="background-color: #FF6600;">
                                                        </figure>
                                                        <div class="details">
                                                            <h5 class="box-title">Comfort Seat</h5>
                                                            <label class="price-wrapper">
                                                                <span class="price-per-unit">30,00 €</span>
                                                                <br />{{ furtherservices_seat_comfortseat[getCurrentLocale] }}
                                                            </label>
                                                        </div>
                                                    </article>

                                                    <article class="box">
                                                        <figure>
                                                            <img src="/res/images/services/seats/types/seat1.png" alt="" width="30" heigth="30" style="background-color: #9900CC;">
                                                        </figure>
                                                        <div class="details">
                                                            <h5 class="box-title">Best Seat</h5>
                                                            <label class="price-wrapper">
                                                                <span class="price-per-unit">20,00 €</span>
                                                                <br />{{ furtherservices_seat_bestseat[getCurrentLocale] }}
                                                            </label>
                                                        </div>
                                                    </article>

                                                    <article class="box">
                                                        <figure>
                                                            <img src="/res/images/services/seats/types/seat1.png" alt="" width="30" heigth="30" style="background-color: #22B14C;">
                                                        </figure>
                                                        <div class="details">
                                                            <h5 class="box-title">Standard Seat</h5>
                                                            <label class="price-wrapper">
                                                                <span class="price-per-unit">12,00 €</span>
                                                            </label>
                                                        </div>
                                                    </article>

                                                    <article class="box">
                                                        <figure>
                                                            <img src="/res/images/services/seats/types/seat1.png" alt="" width="30" heigth="30" style="background-color: #3399FF;">
                                                        </figure>
                                                        <div class="details">
                                                            <h5 class="box-title">Exit Seat</h5>
                                                            <label class="price-wrapper">
                                                                <span class="price-per-unit">30,00 €</span>
                                                                <br />{{ furtherservices_seat_exitseat[getCurrentLocale] }}
                                                            </label>
                                                        </div>
                                                    </article>
                                                </div>
                                            </div>


                                            <div class="long-description">
                                                <p>{{ furtherservices_seat_text1[getCurrentLocale] }} <a href="/services" target="_blank" style="font-size:15.9996px; color: #D6254D;">{{ furtherservices_seat_here[getCurrentLocale] }}</a>.</p><br />
                                                <h4 v-html="furtherservices_seat_text2[getCurrentLocale]" style="color: #D6254D;"></h4><br />
                                                <p>{{ furtherservices_seat_text3[getCurrentLocale] }} <a href="/infos-seat-reservation/#/seat-reservation" target="_blank" style="font-size:15.9996px; color: #D6254D;">{{ furtherservices_seat_here[getCurrentLocale] }}</a>.<p />
                                            </div>
                                        </p>
                                    </div><!-- end content -->
                                </div>
                            </div>
                            <!-- End:TravelExtras-Seat -->

                            <!-- Begin:TravelExtras-Luggage -->
                            <div class="panel style1">
                                <h4 class="panel-title">
                                    <a class="collapsed" href="#acc8" data-toggle="collapse" data-parent="#accordion3">{{ furtherservices_luggage[getCurrentLocale] }}</a>
                                </h4>
                                <div class="panel-collapse collapse" id="acc8">
                                    <div class="panel-content">
                                        <p v-html="luggage_text1[getCurrentLocale]"></p>
                                        <p v-html="luggage_text2[getCurrentLocale]"></p>

                                        <p v-html="luggage_text3[getCurrentLocale]"></p>
                                        <p>{{ luggage_text3b[getCurrentLocale] }} <a href="/infos-luggage/#/luggage" target="_blank" style="font-size:15.9996px; color: #D6254D;">{{ furtherservices_seat_here[getCurrentLocale] }}</a>.</p>

                                        <p>{{ luggage_text4[getCurrentLocale] }} <a href="/services" target="_blank" style="font-size:15.9996px; color: #D6254D;">{{ furtherservices_seat_here[getCurrentLocale] }}</a>.</p>
                                        <p>{{ luggage_text5[getCurrentLocale] }} <a href="/infos-additional-services/#/additional-services" target="_blank" style="font-size:15.9996px; color: #D6254D;">{{ furtherservices_seat_here[getCurrentLocale] }}</a>.</p>

                                        <p v-html="luggage_textlistheader[getCurrentLocale]"></p>
                                        <ul class="check-circle box">
                                            <li v-html="luggage_li1[getCurrentLocale]"></li>
                                            <li v-html="luggage_li2[getCurrentLocale]"></li>
                                            <li v-html="luggage_li3[getCurrentLocale]"></li>
                                        </ul>

                                        <p v-html="luggage_textcontact[getCurrentLocale]"></p>
                                    </div><!-- end content -->
                                </div>
                            </div>

                            <!-- Begin:TravelExtras-Sportequipment -->
                            <div class="panel style1">
                                <h4 class="panel-title">
                                    <a class="collapsed" href="#acc9" data-toggle="collapse" data-parent="#accordion3">{{ furtherservices_sportequipment[getCurrentLocale] }}</a>
                                </h4>
                                <div class="panel-collapse collapse" id="acc9">
                                    <div class="panel-content">
                                        <p>{{ sportequipment_text1[getCurrentLocale] }}</p>

                                        <ul class="check-circle box">
                                            <li v-html="sportequipment_li1[getCurrentLocale]"></li>
                                            <li v-html="sportequipment_li2[getCurrentLocale]"></li>
                                            <li v-html="sportequipment_li3[getCurrentLocale]"></li>
                                            <li v-html="sportequipment_li4[getCurrentLocale]"></li>
                                            <li v-html="sportequipment_li5[getCurrentLocale]"></li>
                                            <li v-html="sportequipment_li6[getCurrentLocale]"></li>
                                            <li v-html="sportequipment_li7[getCurrentLocale]"></li>
                                            <li v-html="sportequipment_li8[getCurrentLocale]"></li>
                                            <li v-html="sportequipment_li9[getCurrentLocale]"></li>
                                            <li v-html="sportequipment_li10[getCurrentLocale]"></li>
                                        </ul>

                                        <p>{{ sportequipment_text3[getCurrentLocale] }} <a href="/infos-additional-services/#/additional-services" target="_blank" style="font-size:15.9996px; color: #D6254D;">{{ furtherservices_seat_here[getCurrentLocale] }}</a>.</p>
                                        <p>{{ sportequipment_text4[getCurrentLocale] }} <a href="/services" target="_blank" style="font-size:15.9996px; color: #D6254D;">{{ furtherservices_seat_here[getCurrentLocale] }}</a>.</p>

                                    </div><!-- end content -->
                                </div>
                            </div>
                            <!-- End:TravelExtras-Sportequipment -->
                        </div>
                    </div>
                    <!-- End:TravelExtras-Left -->


                    <!-- Begin:TravelExtras-Right -->
                    <div class="col-sm-6">
                        <div class="toggle-container with-image box" id="accordion4" data-image-animation-type="zoomIn" data-image-animation-duration="1">
                            <div class="image-container animated fadeIn" data-animation-type="fadeIn" data-animation-duration="3" style="animation-duration: 3s; visibility: visible;">
                                <img src="/res/images/travelextras/tabs02.png" alt="img1" />
                            </div>

                            <!-- Begin:TravelExtras-Meal -->
                            <div class="panel style1">
                                <h4 class="panel-title">
                                    <a class="collapsed" href="#acc11" data-toggle="collapse" data-parent="#accordion4">{{ furtherservices_meal[getCurrentLocale] }}</a>
                                </h4>
                                <div class="panel-collapse collapse" id="acc11">
                                    <div class="panel-content">
                                        <p v-html="meal_text1[getCurrentLocale]"></p>
                                        <p>{{ meal_text2[getCurrentLocale] }} <a href="https://www.sundair.com/downloads/Sundair-Bord-Bistro_and_Travel-Value.pdf" target="_blank" style="font-size:15.9996px; color: #D6254D;">{{ furtherservices_seat_here[getCurrentLocale] }}</a>.</p>
                                        <p>{{ meal_text3[getCurrentLocale] }} <a href="/services" target="_blank" style="font-size:15.9996px; color: #D6254D;">{{ furtherservices_seat_here[getCurrentLocale] }}</a>.</p>
                                    </div><!-- end content -->
                                </div>
                            </div>
                            <!-- End:TravelExtras-Meal -->

                            <!-- Begin:TravelExtras-Furtherservices -->
                            <div class="panel style1">
                                <h4 class="panel-title">
                                    <a class="collapsed" href="#acc12" data-toggle="collapse" data-parent="#accordion4">{{ furtherservices_furtherservices[getCurrentLocale] }}</a>
                                </h4>
                                <div class="panel-collapse collapse" id="acc12">
                                    <div class="panel-content">
                                        <p>{{ furtherservices_text1[getCurrentLocale] }}</p>

                                        <ul class="check-circle box">
                                            <li v-html="furtherservices_li1[getCurrentLocale]"></li>
                                            <li v-html="furtherservices_li2[getCurrentLocale]"></li>
                                            <li v-html="furtherservices_li3[getCurrentLocale]"></li>
                                            <li v-html="furtherservices_li4[getCurrentLocale]"></li>
                                        </ul>

                                        <p> {{ furtherservices_text2[getCurrentLocale] }} <a href="/services" target="_blank" style="font-size:15.9996px; color: #D6254D;">{{ furtherservices_seat_here[getCurrentLocale] }}</a>.</p>
                                        <p> {{ furtherservices_text3[getCurrentLocale] }} <a href="/infos-additional-services/#/additional-services" target="_blank" style="font-size:15.9996px; color: #D6254D;">{{ furtherservices_seat_here[getCurrentLocale] }}</a>.</p>
                                    </div><!-- end content -->
                                </div>
                            </div>
                            <!-- End:TravelExtras-Furtherservices -->
                        </div>
                    </div>
                    <!-- end:TravelExtras-Right -->
                </div>
            </div>
        </div>
        <!-- End:FurtherServices -->
    </section>
    <!-- End:PageContent-FurtherServices, PromoBox -->
</template>

<script>
    import { mapGetters } from 'vuex';


    export default {

        /* >>> *************************************************************** / /* Components */
        components: {

        }, // eof components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                contentheadline: {
                    en: 'Travel extras to enrich your trip',
                    de: 'Reise Extras zur Bereicherung Ihrer Reise',
                },
                // >>> ------------------------------------
                // >>> ------------------------------------
                furtherservices_seat: {
                    en: 'Reserve your seat of choice',
                    de: 'Reservieren Sie sich Ihren Wunschsitzplatz',
                },
                furtherservices_seat_headline: {
                    en: 'The following seating categories are available:',
                    de: 'Folgende Sitzplatzkategorien stehen zur Wahl:',
                },
                furtherservices_seat_text1: {
                    en: 'You can choose whether you want to sit at the window and enjoy the view or sit in the corridor with more freedom of movement. Decide for yourself and book your new favourite place',
                    de: 'Sie können wählen, ob Sie am Fenster sitzen und die Aussicht genießen wollen oder am Gang mit mehr Bewegungsfreiheit sitzen möchten. Entscheiden Sie selbst und buchen Ihren neuen Lieblingsplatz',
                },
                furtherservices_seat_here: {
                    en: 'here',
                    de: 'hier',
                },
                furtherservices_seat_text2: {
                    en: 'Attention: We recommend that you make your reservation up to 48 hours before departure!',
                    de: 'Achtung: Wir empfehlen Ihnen eine rechtzeitige Reservierung<br /> bis 48 Stunden vor Abflug!',
                },
                furtherservices_seat_text3: {
                    en: 'Further information can be found',
                    de: 'Nähere Informationen finden Sie',
                },
                furtherservices_seat_comfortseat: {
                    en: 'SEATS IN THE 1ST ROW',
                    de: 'SITZPLÄTZE IN DER 1. REIHE',
                },
                furtherservices_seat_bestseat: {
                    en: 'Seats in the 2nd - 7th row',
                    de: 'Sitzplätze in der 2.-7. Reihe',
                },
                furtherservices_seat_exitseat: {
                    en: 'SEATS DIRECTLY AT THE EMERGENCY EXIT',
                    de: 'SITZPLÄTZE AM NOTAUSGANG',
                },


                // >>> ------------------------------------
                // >>> ------------------------------------
                furtherservices_luggage: {
                    en: 'Take extra luggage with you',
                    de: 'Nehmen Sie zusätzliches Gepäck mit',
                },
                luggage_text1: {
                    en: 'Checked baggage allowance up to <b>max. 20kg</b>.',
                    de: 'Aufzugebenes Freigepäckstück bis <b>max. 20kg</b>.',
                },
                luggage_text2: {
                    en: 'Baggage allowance for small children up to 2 years such as pushchairs, buggies or child car seats can be carried in the hold without registration within the free baggage allowance up to 20kg.',
                    de: 'Gepäckstücke für Kleinkinder bis 2 Jahre wie  Kinderwagen, Buggys oder Autokindersitze können ohne Anmeldung innerhalb der Freigepäckmenge  bis max. 20 kg im Laderaum befördert werden.',
                },

                luggage_text3: {
                    en: 'One (1) Hand luggage up to max. 6kg with permissible dimensions up to 55cm x 40cm x 20cm.',
                    de: 'Ein (1) Handgepäck bis max. 6 kg mit den zulässigen Abmessungen bis 55cm x 40cm x 20cm.',
                },
                luggage_text3b: {
                    en: 'Please note the following information on the EU hand baggage regulations for liquids and our liability regulations under Information Baggage',
                    de: 'Bitte beachten Sie folgende Hinweise zu den EU-Handgepäckregelungen für Flüssigkeiten und unseren Haftungsbestimmungen unter Informationen-Gepäck',
                },
                luggage_text4: {
                    en: 'Over-, sports- or special baggage can be booked up to 48 hours before departure',
                    de: 'Über-, Sport- oder Sondergepäck können bis spätestens 48 Stunden vor Abflug hier gebucht werden',
                },
                luggage_text5: {
                    en: 'The price list can be found',
                    de: 'Eine Entgelt-Übersicht hierzu finden Sie',
                },
                luggage_textlistheader: {
                    en: 'The following items can also be taken with you by prior arrangement and confirmation:',
                    de: 'Nach vorheriger Anmeldung und Bestätigung können außerdem folgende Gegenstände mitgenommen werden:',
                },
                luggage_li1: {
                    en: 'up to two mobility devices',
                    de: 'bis zu zwei Mobillitätshilfen',
                },
                luggage_li2: {
                    en: 'a pair of assistants and/or splints, other prostheses',
                    de: 'ein Paar Gehilfen und/ oder Schienen, sonstige Prothesen',
                },
                luggage_li3: {
                    en: 'a guide dog',
                    de: 'einen Blindenhund',
                },
                luggage_textcontact: {
                    en: 'Please contact our customer service on <b>+49 30 53676791</b> for more information.',
                    de: 'Bitte kontaktieren Sie hierzu unseren Kundenservice unter <span style="font-size:15.9996px; color: #D6254D;">+49 30 53676791</span>.',
                },
                // >>> ------------------------------------
                // >>> ------------------------------------
                furtherservices_sportequipment: {
                    en: 'Travel with your sports equipment',
                    de: 'Verreisen Sie mit Ihrem Sportequipment',
                },
                sportequipment_text1: {
                    en: 'We can transport the following equipment for you our aircraft:',
                    de: 'Folgendes Sportgepäck können wir für Sie in unseren Flugzeugen befördern:',
                },
                sportequipment_li1 : {
                    en: 'Bicycle up to 20kg',
                    de: 'Fahrrad bis 20kg',
                },
                sportequipment_li2 : {
                    en: 'Golf baggage up to 20kg',
                    de: 'Golfgepäck bis 20kg',
                },
                sportequipment_li3 : {
                    en: 'Diving baggage up to 30kg',
                    de: 'Tauchgepäck bis 30kg',
                },
                sportequipment_li4 : {
                    en: 'Surfboard up to 30kg',
                    de: 'Surfboard bis 30kg',
                },
                sportequipment_li5 : {
                    en: 'Waveboard up to 30kg',
                    de: 'Waveboard bis 30kg',
                },
                sportequipment_li6 : {
                    en: 'Kayak up to 30kg',
                    de: 'Kajak bis 30kg',
                },
                sportequipment_li7 : {
                    en: 'Kiteboard up to 30kg',
                    de: 'Kiteboard bis 30kg',
                },
                sportequipment_li8 : {
                    en: 'Hangglider up to 30kg',
                    de: 'Hangglider bis 30kg',
                },
                sportequipment_li9 : {
                    en: 'Canoe up to 30kg',
                    de: 'Kanu bis 30kg',
                },
                sportequipment_li10 : {
                    en: 'Paraglider up to 30kg',
                    de: 'Paraglider bis 30kg',
                },
                sportequipment_text3: {
                    en: 'Without reservation at check-in, higher fees may apply. Detailed information and the price list can be found',
                    de: 'Ohne vorherige Reservierung fallen bei Abgabe am Check-in höhere Gebühren an. Detaillierte Informationen und die Entgelte finden Sie',
                },
                sportequipment_text4: {
                    en: 'Please reserve sports equipment',
                    de: 'Reservieren Sie Ihr Sport- und Sondergepäck noch heute online',
                },
                // >>> ------------------------------------
                // >>> ------------------------------------
                furtherservices_meal: {
                    en: 'Simply order your meal before',
                    de: 'Bestellen Sie doch einfach Ihr Essen vor',
                },
                meal_text1: {
                    en: 'On your flight we offer you a selection of food, snacks and drinks for sale.',
                    de: 'Gerne bieten wir Ihnen eine Auswahl an Speisen, Snacks und Getränke gegen Gebühr auf Ihrem Flug an.',
                },
                meal_text2: {
                    en: 'Further information can be found in our on-board bistro and sales journal (PDF document)',
                    de: 'Nähere Informationen finden Sie in unserem Bord-Bistro- und Bordverkauf-Journal (PDF-Dokument)',
                },
                meal_text3: {
                    en: 'Special foods such as vegetarian-meals, gluten-free meals and diabetics-menus can be booked at least 48 hours prior to departure under SERVICE',
                    de: 'Spezialessen, wie vegetarisches Essen, glutenfreies Essen und Diabetiker-Essen können Sie bis spätestens 48 Stunden vor Abflug unter Service buchen',
                },
                // >>> ------------------------------------
                // >>> ------------------------------------
                furtherservices_furtherservices: {
                    en: 'Further services for you',
                    de: 'Weitere Services für Sie',
                },
                furtherservices_text1: {
                    en: 'In addition, we offer the following services:',
                    de: 'Zusätzlich bieten wir Ihnen folgende Leistungen an:',
                },
                furtherservices_li1: {
                    en: 'Unaccompanied child <b>60,00€</b> for online registration',
                    de: 'Unbegleitetes Kind <b>60,00€</b> bei Online-Anmeldung',
                },
                furtherservices_li2: {
                    en: 'Animals in the cabin up to <b>6kg incl. box max. 42x31x20cm 60,00€</b> for online registration',
                    de: 'Tiere in der Kabine bis <b>6kg inkl. Box max. 42x31x20cm 60,00€</b> bei Online-Anmeldung',
                },
                furtherservices_li3: {
                    en: 'Animals in the cargo compartment up to <b>20kg incl. box 80,00€</b> for online registration',
                    de: 'Tiere im Frachtraum bis <b>20kg inkl. Box 80,00€</b> bei Online-Anmeldung',
                },
                furtherservices_li4: {
                    en: 'Animals in the hold <b>ab 21kg incl. box 100,00€</b> for online registration',
                    de: 'Tiere im Frachtraum <b>ab 21kg inkl. Box 100,00€</b> bei Online-Anmeldung',
                },
                furtherservices_text2: {
                    en: 'Book your additional services now under Service',
                    de: 'Buchen Sie jetzt Ihre Zusatzleistungen unter Service',
                },
                furtherservices_text3: {
                    en: 'Further information and prices can be found',
                    de: 'Nähere Informationen und Preise finden Sie',
                },
                // currentLocale: 'de',
            };

        }, // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
                'getFlagSharedShowFlightSearchResults',
            ]),

        }, // eof computed{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    a[target="_blank"]:after {
        font-family: 'FontAwesome';
        content: " \f08e";
    }

    .toggle-container .panel.style1 .panel-content {
        padding: 10px 40px 15px 55px;
    }





    /* >>> SearchResult iPAD -------------------------------------------------*/
    @media only screen
    and (min-device-width : 768px)
    and (max-device-width : 1024px)  {
        h1 {
            font-size: 1.5em;
        }

        .toggle-container .panel h4.panel-title {
            font-size: 1.2em;
        }

        .toggle-container .panel.style1 .panel-content {
            padding-top: 10px;
            padding-right: 15px;
            padding-bottom: 15px;
            padding-left: 15px;
        }
    }
</style>
